import api from '@/apis/pa/paLayoutTemplateAPI.js';
import { usefilterActionCombo } from './filterActionCombo.js';
import { getCurrentInstance } from 'vue';

// Combo grid Phòng ban
export const usePaLayoutTemplateComboGrid = (comboboxDataRemote, comboboxLoadData) => {
  const { proxy } = getCurrentInstance();
  const { extendFilter } = usefilterActionCombo();
  // func call api lấy dữ liệu combo
  const onPaLayoutTemplateComboboxLoadData = (payload, row, column) => {
    payload.sort = 'sort_order';
    let extend = [{ Field: 'active', Value: true }];
    payload.filter = extendFilter(payload.filter, extend);
    comboboxLoadData(payload, api, comboboxDataRemote, column.dataField);
  };

  // config columns combo
  const paLayoutTemplateComboConfig = {
    data: comboboxDataRemote,
    columns: [
      {
        title: 'Mã',
        dataField: 'pa_layout_template_id',
        width: 120,
        filterOperator: proxy.$ms.constant.FilterOperator.StartsWith,
      },
      {
        title: 'Tên',
        dataField: 'template_name',
        filterOperator: proxy.$ms.constant.FilterOperator.Contains,
        width: 480,
      },
    ],
    displayField: 'template_name',
    valueField: 'pa_layout_template_id',
    queryMode: 'remote',
    dropdownWidth: 600,
    comboboxLoadData: onPaLayoutTemplateComboboxLoadData,
  };

  // Sự kiện load combo trên grid
  return {
    paLayoutTemplateComboConfig,
    onPaLayoutTemplateComboboxLoadData, // trả về thêm để dùng chung cho cả combo không thuộc grid
  };
};
